import "./Tags.css";

/*
  Tags Component

  variant:
  primary / success / warning / danger / info / neutral

  appearance:
  soft     = خلفية خفيفة
  outline  = حدود فقط
  filled   = خلفية أوضح
  ghost    = بدون خلفية قوية

  content:
  text فقط، icon فقط، أو icon + text
*/

const Tags = ({
  children,
  variant = "primary",
  appearance = "soft",
  size = "md",
  icon,
  closable = false,
  interactive = false,
  onClose,
  closeLabel,
  title,
  className = "",
}) => {
  const textLabel =
    typeof children === "string" || typeof children === "number" ? children : "";
  return (
    <span
      title={title}
      className={`ui-tag ${variant} ${appearance} ${size} ${
        interactive ? "interactive" : ""
      } ${className}`}
    >
      {icon && <span className="ui-tag-icon">{icon}</span>}

      {children && <span className="ui-tag-text">{children}</span>}

      {closable && (
        <button
          type="button"
          className="ui-tag-close"
          aria-label={closeLabel || (textLabel ? `Remove ${textLabel}` : "Remove")}
          onClick={onClose}
        >
          <span aria-hidden="true">×</span>
        </button>
      )}
    </span>
  );
};

export default Tags;